module.exports = __webpack_public_path__ + "img/E_SDG_Icons-06.61b2ee6a.jpg";